import React from 'react';
import DocumentTitle from 'react-document-title';
import { FormattedMessage } from 'react-intl';
import { ModalConfirm } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import {
  TableHeader,
  Table,
} from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import TableLayout from '../../components/TableLayout';
import Summary from './Summary';
import UnitSpecials from './UnitSpecials';
import GoBackLinks from './GoBackLinks';
import useManageUnitAvailability from './hooks';
import messages from '../ManageUnitAvailability/messages';
import useBaseTableProps from '../../hooks/useBaseTableProps';
import AffordableTransferBanner from './AffordableTransferBanner';
import MixedPropertyAffordableTransferBanner from './MixedPropertyAffordableTransferBanner';
import AssignmentRestrictionBanner from './AssignmentRestrictionBanner';
import { useFlags } from 'launchdarkly-react-client-sdk';
import NaurWarning from '../../components/NaurWarningWrapper';
import TransferNavigationWarningBanner from './TransferNavigationWarningBanner';
const NAME = 'manage-unit-availability';
const ManageUnitAvailability = () => {
  const baseTableProps = useBaseTableProps();
  const {
    allColumnsHidden,
    applicantToAssignUnit,
    assignUnitProps,
    columnOptions,
    count,
    countName,
    dateState,
    filterState,
    filterTypeState,
    filteredHeaders,
    footerRow,
    handleColumnChange,
    handleDateSubmit,
    handleFilterChange,
    handleFilterTypeChange,
    handleSearchSubmit,
    handleSortChange,
    handleTruncateChange,
    intl,
    isLoading,
    name,
    onCSVButtonClick,
    order,
    orderBy,
    restriction,
    rows,
    searchState,
    selectedColumns,
    sortedAndFilteredResults,
    totalCount,
    HUDTransferProps,
    isMixedProperty,
    selectedProperty,
  } = useManageUnitAvailability({ NAME });
  const { naur } = useFlags();

  return (
    <DocumentTitle
      data-testid={NAME}
      title={intl.formatMessage(messages.title)}
    >
      <>
        <TableLayout
          name={name}
          childrenElementsHeight={50 + 8 + 126 + 36 + 5}
          watch={['unit-specials', 'collapse']}
        >
          {(tableHeight) => (
            <>
              <TableHeader
                id={'table-header'}
                title={<FormattedMessage {...messages.header} />}
                count={count}
                countName={countName}
                totalCount={totalCount}
                actions={
                  <GoBackLinks applicantToAssignUnit={applicantToAssignUnit} />
                }
              />

              {naur && (
                <NaurWarning
                  variant="property-generic"
                  propertyId={selectedProperty.id}
                />
              )}

              <TransferNavigationWarningBanner />

              <MixedPropertyAffordableTransferBanner
                isMixedProperty={isMixedProperty}
              />
              <AssignmentRestrictionBanner restriction={restriction} />

              <UnitSpecials />

              <Summary
                name={name}
                isLoading={isLoading}
                sortedAndFilteredResults={sortedAndFilteredResults}
              />
              <AffordableTransferBanner HUDTransferProps={HUDTransferProps} />
              <Table
                {...baseTableProps}
                allColumnsHidden={allColumnsHidden}
                columnOptions={columnOptions}
                dateState={dateState}
                filterState={filterState}
                filterTypeState={filterTypeState}
                footerRow={footerRow}
                handleColumnChange={handleColumnChange}
                handleDateSubmit={handleDateSubmit}
                handleFilterChange={handleFilterChange}
                handleFilterTypeChange={handleFilterTypeChange}
                handleSearchSubmit={handleSearchSubmit}
                handleSortChange={handleSortChange}
                handleTruncateChange={handleTruncateChange}
                headers={filteredHeaders}
                height={tableHeight}
                isLoading={isLoading}
                onCSVButtonClick={onCSVButtonClick}
                name={name}
                order={order}
                orderBy={orderBy}
                rows={rows}
                count={count}
                searchState={searchState}
                selectedColumns={selectedColumns}
                totalCount={totalCount}
              />
            </>
          )}
        </TableLayout>
        <ModalConfirm
          actionsProps={assignUnitProps.actionsProps}
          onClose={assignUnitProps.onClose}
          open={assignUnitProps.openConfirm}
          title={assignUnitProps.title}
        />
      </>
    </DocumentTitle>
  );
};

export default ManageUnitAvailability;
